import { LitElement, html, css } from 'lit';
import { completedPageIcon, currentPageIcon, arrow } from '../../utilities/icons';
import { accessibility, formStyles } from '../../utilities/styles';
import { EventManager } from '../../utilities/events';
export class AllInPagedFormStepCounter extends LitElement {
    static properties = {
        type: { type: String },
        name: { type: String },
        _pages: { state: true, type: Array },
        _form: { state: true },
        _currentPage: { state: true, type: Number },
        _success: { state: true, type: Boolean },
        _successTitle: { state: true, type: String },
        _successSubTitle: { state: true, type: String },
        _subPages: { state: true, type: Array },
        _currentSubPage: { state: true, type: Object },
    };
    constructor() {
        super();
        this._errorMessage = '';
        if (!this.redirect) {
            this.redirect = '/';
        }
        this._currentPage = 0;
        this._pages = [];
        this._isLastPage = false;
        this.init = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
        this.eventManager.listen(`allin-paged-form-page-data`, this._init);
        this.eventManager.listen(`allin-paged-form-current-page`, this._setPage);
        this.eventManager.listen(`allin-page-subpages-processed`, this._subpagesProcessed);
        this.eventManager.listen(`allin-page-subpage-shown`, this._subpageShown);
        this.eventManager.listen(`allin-paged-form-success`, this._successHandler);
    }
    render() {
        if (this.type == 'full') {
            return html `\n            <ul class="step_counter" title="Step counter for the form" aria-live="polite">\n                ${this._pages.map((page, i) => {
                let icon = '';
                let status = 'incomplete';
                let statusString = 'incomplete';
                let step = `${i + 1}`;
                let subs = '';
                if (this._success) {
                    icon = arrow;
                    status = 'completed';
                    statusString = 'completed';
                }
                else if (i == this._currentPage) {
                    icon = arrow;
                    status = 'current" aria-current="step"';
                    if (page.subPages) {
                        subs = html `\n                        <ul class="step_counter sub_step_counter" title="Substeps for step ${i + 1}: ${page.title}" aria-live="polite">\n                            ${page.subPages.map((subPage, j) => {
                            let substatus = subPage.isCurrent() ? 'current' : '';
                            let subStatusAria = subPage.isCurrent() ? 'step' : '';
                            let completed = !substatus && subPage.isCompleted() ? 'completed' : '';
                            let subicon = '';
                            if (substatus) {
                                status = 'has_sub_pages';
                                icon = arrow;
                                subicon = arrow;
                            }
                            if (completed) {
                                subicon = completedPageIcon;
                                substatus = 'completed';
                            }
                            return html `\n                                <li class="step_counter--step-full ${substatus}" ?aria-current=${subStatusAria}> \n                                    <button @click=${this._onClickSubPage} data-index="${j}" aria-label="Step ${i + 1}.${j + 1}: ${subPage.title}">\n                                        <span class="screen-reader-text">${substatus}}</span>\n                                        <span class="icon" aria-hidden="true">${subicon}</span>\n                                        <span class="step_counter--step-title">${step}.${j + 1}: ${subPage.title}</span>\n                                    </button>\n                                </li>`;
                        })}\n                        </ul>\n                        `;
                    }
                }
                else if (i < this._currentPage) {
                    icon = completedPageIcon;
                    status = 'completed';
                    statusString = 'completed';
                    if (page.subPages) {
                        for (let k = 0; k < page.subPages.length; k++) {
                            if (!page.subPages[k].isCompleted()) {
                                status = 'partial';
                                break;
                            }
                        }
                    }
                    return html `\n                    <li class="step_counter--step-full ${status}" >\n                        <button @click=${this._onClick} data-index="${i}">\n                            <span class="screen-reader-text">${statusString}}</span>\n                            <span class="icon" aria-hidden="true">${icon}</span>\n                            <span class="step_counter--step-title">${step}: ${page.title}</span>\n                        </button>\n                    </li>`;
                }
                else if (page.completed) {
                    icon = completedPageIcon;
                    status = 'partial';
                    return html `\n                    <li class="step_counter--step-full ${status}" >\n                        <button @click=${this._onClick} data-index="${i}">\n                            <span class="screen-reader-text">${status}</span>\n                            <span class="icon" aria-hidden="true">${icon}</span>\n                            <span class="step_counter--step-title">${step}: ${page.title}</span>\n                        </button>\n                    </li>`;
                }
                else {
                    icon = '';
                }
                return html `\n                    <li class="step_counter--step-full ${status}" >\n                        <div>\n                            <span class="screen-reader-text">${status}}</span>\n                            <span class="icon" aria-hidden="true">${icon}</span>\n                            <span class="step_counter--step-title">${step}: ${page.title}</span>\n                        </div>\n                        ${subs}\n                    </li>`;
            })}\n            </ul>\n            `;
        }
        if (this.type == 'title') {
            if (this._success) {
                return html `<span class="step_counter--title">${this._successTitle}</span>`;
            }
            return html `<span class="step_counter--title">${this._pages[this._currentPage]?.title}</span>`;
        }
        if (this.type == 'step') {
            if (this._success) {
                return html `<span class="step_counter--step">${this._successSubTitle}</span>`;
            }
            return html `<span class="step_counter--step">${parseInt(this._currentPage) + 1} of ${this._pages.length}</span>`;
        }
        if (this.type == 'step-title') {
            if (this._success) {
                return html `<span class="step_counter--step-title">${this._successSubTitle}</span>`;
            }
            return html `<span class="step_counter--step-title">${parseInt(this._currentPage) + 1}: ${this._pages[this._currentPage]?.title}</span>`;
        }
    }
    _onClick(e) {
        e.preventDefault();
        let index = e.currentTarget.dataset.index;
        this.changePage(index);
    }
    _onClickSubPage(e) {
        e.preventDefault();
        let index = e.currentTarget.dataset.index;
        let parentIndex = this._currentPage;
        this.changeSubPage(index, parentIndex);
    }
    changePage(index) {
        this._form.changePage(index);
    }
    changeSubPage(index, parentIndex) {
        this._form.changeSubPage(index, parentIndex);
    }
    _init(e) {
        if (e.detail.name == this.name) {
            this._pages = e.detail.data;
            this._form = e.detail.el;
        }
    }
    _setPage(e) {
        if (e.detail.name == this.name) {
            this._currentPage = e.detail.index;
            this._pages[this._currentPage].completed = true;
            if (!this.init) {
                this.init = true;
                for (let i = 0; i < this._currentPage; i++) {
                    this._pages[i].completed = true;
                }
            }
        }
    }
    _successHandler(e) {
        this._successTitle = e.detail.title;
        this._successSubTitle = e.detail.subTitle;
        this._success = true;
    }
    _subpagesProcessed(e) {
        let page = this._pages.find(p => p.el == e.detail.el);
        page.subPages = e.detail.subPages;
        this._pages = [...this._pages];
    }
    _subpageShown(e) {
        this._currentSubPage = e.detail.index;
    }
    static styles = [
        accessibility,
        formStyles,
        css `
            .step_counter{
                list-style: none;
                margin:0;
                padding:0;
                position: relative;
            }

            .step_counter:before{
                content: '';
                position: absolute;
                top: 0;
                left: 1.375rem;
                width: 0.25rem;
                height: calc(100% - 2rem);
                background: var(--color-grey-to-secondary-lighter, #E8E8E8);
            }
            .step_counter--step-full{
                position:relative;
                z-index:1;
            }

            .step_counter--step-full>div, .step_counter--step-full.completed button, .step_counter--step-full.partial button, .sub_step_counter .step_counter--step-full button{
                display: grid;
                grid-template-columns: 3rem 1fr;
                gap:0.75rem;
                margin-bottom:2rem;
                align-items: center;
            }

            .step_counter--step-full .step_counter--step-title{
                font-size:0.85rem;
                font-family: var(--font-primary, 'Montserrat');
                color: var(--title-color, #472961);
                text-align: left;
            }

            .step_counter--step-full.completed, 
            .step_counter--step-full.partial{
                display:grid;
            }

            .step_counter--step-full.completed button,
            .step_counter--step-full.partial button,
             .sub_step_counter .step_counter--step-full button{
                background: none;
                border: none;
                cursor: pointer;
                padding:0;
                padding:0;
            }

            .step_counter--step-full.completed button:hover,
            .step_counter--step-full.partial button:hover{
                text-decoration: underline;
            }

            .step_counter--step-full.completed .step_counter--step-title, .step_counter--step-full.current .step_counter--step-title{
                font-weight: bold;
            }

            
            .icon{
                height:3rem;
                border-radius:50%;
                display: flex;
                align-items: center;
                justify-content: center;
                border: 3px solid var(--color-grey-to-secondary-lighter, #E8E8E8);
                box-sizing: border-box;
            }

            .icon svg path{
                fill: var(--color-black-to-white);
            }
            .step_counter--step-full .icon{
                background: var(--color-bg, #fff);
            }

            .step_counter--step-full.completed .icon{
                border-color: var(--color-primary, #FFCE58);
                background: var(--color-primary, #FFCE58);
            }
            
            .step_counter--step-full.partial .icon path{
                fill: var(--color-primary, #FFCE58);
            }

            .step_counter--step-full.completed+.step_counter--step-full.completed::before
            {
                content: '';
                position: absolute;
                bottom: 2rem;
                left: 1.375rem;
                width: 0.25rem;
                height: 100%;
                background: var(--color-primary, #E8E8E8);
                z-index: -1;
            }
            .step_counter--step-full.current .icon{
                border-color: var(--color-grey-to-subnav-hover, #FFCE58);
                background: var(--color-grey-to-subnav-hover, #E8E8E8);
            } 
            .step_counter--title{
                hyphens:auto;
                word-break:break-word;
            }

            .has_sub_pages>div .icon{
                border-color: var(--color-primary, #FFCE58);
            }
            .step_counter--step-full.completed+.has_sub_pages::before{
                content: '';
                position: absolute;
                bottom: 2rem;
                left: 1.375rem;
                width: 0.25rem;
                height: 100%;
                background: var(--color-primary, #E8E8E8);
                z-index: -1;
            }
            .sub_step_counter .step_counter--step-full:not(.current) button:hover{
                text-decoration: underline;
            }
        `
    ];
}
